var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.283,
    height: 21.282,
    viewBox: "0 0 21.283 21.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(-1061.978 -4105.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 10.641,
    cy: 10.641,
    r: 10.641,
    transform: "translate(1061.978 4105.52)",
    fill: "#44927d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M1067.585,4116.672c-.889-.889-2.285.507-1.4,1.4,1.2,1.206,2.285,2.411,3.489,3.554.509.442.953.508,1.4,0l8.377-8.376a.987.987,0,0,0-1.4-1.4l-7.614,7.678Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.e81887962436f5fbd633ef10b5231954.svg";
export { ForwardRef as ReactComponent };